export default __webpack_public_path__ + "static/media/greetings.7f871199.jpg";